var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { justify: "center", dense: "" } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "6", md: "3" } },
        [
          _c("v-select", {
            attrs: {
              items: _vm.transportTypes,
              "item-text": "name",
              "item-value": "id",
              "error-messages": _vm.modelTransportTypeValidation,
              label: _vm.$t(
                "delegation.form.fields.transport.transportType.name"
              ),
              readonly: _vm.$store.state.Delegation.readonly === true,
              "persistent-hint": "",
              hint: _vm.validationTransportType,
              "background-color":
                _vm.validationTransportType !== null ? "blue lighten-5" : null
            },
            model: {
              value: _vm.contextTransportType,
              callback: function($$v) {
                _vm.contextTransportType = $$v
              },
              expression: "contextTransportType"
            }
          })
        ],
        1
      ),
      _vm.modelTransportType !== 1
        ? _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "3" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.settlementTypes(_vm.modelTransportType),
                  "error-messages": _vm.modelSettlementTypeIdValidation,
                  label: _vm.$t(
                    "delegation.form.fields.transport.settlementType.name"
                  ),
                  readonly: _vm.$store.state.Delegation.readonly === true
                },
                model: {
                  value: _vm.contextSettlementTypeId,
                  callback: function($$v) {
                    _vm.contextSettlementTypeId = $$v
                  },
                  expression: "contextSettlementTypeId"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: "12", sm: "12", md: "6" } },
        [
          _c("v-text-field", {
            attrs: {
              label: _vm.$t("delegation.form.fields.transport.comment.name"),
              "error-messages": _vm.modelCommentValidation,
              readonly: _vm.$store.state.Delegation.readonly === true
            },
            model: {
              value: _vm.contextComment,
              callback: function($$v) {
                _vm.contextComment = $$v
              },
              expression: "contextComment"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }